export const styles: { [key: string]: React.CSSProperties } = {
  // Main container
  container: {
    minHeight: '100vh',
    backgroundColor: '#f8fafc',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    overflow: 'hidden',
  },

  // Header styles
  header: {
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #e2e8f0',
    padding: '12px 20px',
    borderRadius: '12px',
    border: '1px solid #e2e8f0',
    boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
    margin: '10px'
  },
  headerTop: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '92%',
    margin: '0 auto',
  },
  title: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#0f172a',
    margin: '0 0 2px 0',
    letterSpacing: '-0.02em',
  },
  subtitle: {
    fontSize: '11px',
    color: '#64748b',
    margin: 0,
    fontWeight: '500',
  },
  headerBadge: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '4px 10px',
    backgroundColor: '#f0fdf4',
    borderRadius: '16px',
    border: '1px solid #bbf7d0',
  },
  liveDot: {
    width: '6px',
    height: '6px',
    backgroundColor: '#22c55e',
    borderRadius: '50%',
    animation: 'pulse 2s infinite',
  },
  liveText: {
    fontSize: '11px',
    fontWeight: '600',
    color: '#166534',
  },

  // KPI Section
  kpiSection: {
    padding: '5px',
    maxWidth: '90%',
    margin: '0px auto',
  },
  kpiGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '12px',
  },
  metricCard: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    padding: '14px',
    transition: 'all 0.3s',
  },
  metricHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '10px',
  },
  metricIcon: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  trendBadge: {
    fontSize: '10px',
    fontWeight: '700',
    padding: '3px 8px',
    borderRadius: '10px',
  },
  metricBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  metricLabel: {
    fontSize: '10px',
    color: '#64748b',
    margin: 0,
    fontWeight: '600',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  metricValueRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: '6px',
  },
  metricValue: {
    fontSize: '24px',
    fontWeight: '700',
    lineHeight: '1',
    letterSpacing: '-0.02em',
  },
  metricUnit: {
    fontSize: '12px',
    color: '#94a3b8',
    fontWeight: '600',
  },
  metricSubtitle: {
    fontSize: '10px',
    color: '#94a3b8',
    margin: 0,
    fontWeight: '500',
  },

  // Charts Section
  chartsSection: {
    padding: '0 20px 16px',
    maxWidth: '1943px',
    margin: '0 auto',
  },
  chartRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '12px',
    marginBottom: '12px',
  },
  chartCardLarge: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    padding: '14px',
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1)',
  },
  chartCardMedium: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    padding: '14px',
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1)',
  },
  chartHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px',
  },
  chartTitle: {
    fontSize: '13px',
    fontWeight: '700',
    color: '#0f172a',
    margin: '0 0 2px 0',
  },
  chartSubtitle: {
    fontSize: '10px',
    color: '#64748b',
    margin: 0,
    fontWeight: '500',
  },
  chartContainer: {
    minHeight: '180px',
  },

  // Work Log Section
  workLogSection: {
    padding: '0 20px 16px',
    maxWidth: '1440px',
    margin: '0 auto',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  sectionTitle: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#0f172a',
    margin: '0 0 2px 0',
  },
  sectionSubtitle: {
    fontSize: '11px',
    color: '#64748b',
    margin: 0,
    fontWeight: '500',
  },
  filterBar: {
    display: 'flex',
    gap: '8px',
    flexWrap: 'wrap',
  },
  filterBtn: {
    padding: '6px 12px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    backgroundColor: '#ffffff',
    color: '#475569',
    fontSize: '11px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
  },
  filterBtnActive: {
    backgroundColor: '#0ea5e9',
    color: '#ffffff',
    borderColor: '#0ea5e9',
  },
  filterBadge: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    padding: '2px 6px',
    borderRadius: '8px',
    fontSize: '10px',
    fontWeight: '700',
  },

  // Table styles
  tableCard: {
    backgroundColor: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '10px',
    overflow: 'hidden',
    boxShadow: '0 1px 3px 0 rgba(0,0,0,0.1)',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    textAlign: 'left',
    padding: '10px 14px',
    fontSize: '10px',
    fontWeight: '700',
    color: '#64748b',
    backgroundColor: '#f8fafc',
    borderBottom: '2px solid #e2e8f0',
    cursor: 'pointer',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  thContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  sortIcon: {
    fontSize: '10px',
    color: '#0ea5e9',
  },
  tr: {
    transition: 'background-color 0.15s ease',
    borderBottom: '1px solid #f1f5f9',
  },
  td: {
    padding: '10px 14px',
    fontSize: '11px',
    color: '#334155',
    verticalAlign: 'middle',
  },

  // Table cell content styles
  dateText: {
    fontSize: '11px',
    fontWeight: '500',
    color: '#475569',
  },
  employeeCell: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  employeeAvatar: {
    width: '28px',
    height: '28px',
    borderRadius: '6px',
    backgroundColor: '#0ea5e915',
    color: '#0ea5e9',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '11px',
    fontWeight: '700',
  },
  employeeName: {
    fontWeight: '600',
    color: '#0f172a',
    fontSize: '11px',
    marginBottom: '1px',
  },
  employeeId: {
    fontSize: '9px',
    color: '#94a3b8',
    fontWeight: '500',
  },
  titleText: {
    fontWeight: '500',
    color: '#334155',
  },
  taskTag: {
    display: 'inline-block',
    padding: '3px 8px',
    backgroundColor: '#f1f5f9',
    borderRadius: '5px',
    fontSize: '10px',
    fontWeight: '600',
    color: '#475569',
  },
  timeText: {
    fontSize: '10px',
    color: '#64748b',
    fontWeight: '500',
    fontFamily: 'monospace',
  },
  hoursText: {
    fontSize: '12px',
    fontWeight: '700',
    color: '#0f172a',
  },
  statusBadge: {
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '9px',
    fontWeight: '700',
    display: 'inline-block',
    textTransform: 'uppercase',
    letterSpacing: '0.03em',
  },
  statusCompleted: {
    backgroundColor: '#d1fae5',
    color: '#065f46',
  },
  statusProgress: {
    backgroundColor: '#dbeafe',
    color: '#1e40af',
  },
};

export const cssStyles = `
  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
  }
  .metric-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1);
    border-color: #cbd5e1;
  }
  .table-row:hover {
    background-color: #f8fafc;
  }
  button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  }
  button:active {
    transform: translateY(0);
  }
  @media (max-width: 1200px) {
    .chart-row {
      grid-template-columns: 1fr !important;
    }
  }
  @media (max-width: 768px) {
    .kpi-grid {
      grid-template-columns: 1fr !important;
    }
    .section-header {
      flex-direction: column;
      align-items: flex-start;
    }
  }
`;